export default __webpack_public_path__ + "static/media/pdf-blue.190c1fe2.svg";